import homifyLogo from "../../assets/icons/logo-homify-2.png";
import ywLogo from "../../assets/icons/yourwatches.logo.png";
import systelLogo from "../../assets/icons/systel.logo.png";
import tend from "../../assets/icons/trabajo-en-digital.png";
import logo from "../../assets/logo/logo_small_icon_only.png";
export const WorkData = [
  {
    company: "Front-End Developer at Trabajo en Digital",
    designation: "Front-End Developer",
    dateJoining: "05-2023",
    companyLogo: tend,
    work: "- Developed the front-end of a job board page, using technologies such as Next.js, Tailwind, and React Query to achieve an attractive and functional user interface. Made significant contributions to the project's code by implementing innovative solutions and improving development efficiency.",
    location: "México-Remote",
    es: {
      company: "Front-End Developer en Trabajo en Digital",
      designation: "Desarrollador Front-End",
      dateEnd: "Actualidad",
      work: "- Desarrollé el front-end de una página de búsqueda de empleo utilizando tecnologías como Next.js, Tailwind y React Query para lograr una interfaz de usuario atractiva y funcional. Realicé contribuciones significativas al código del proyecto implementando soluciones innovadoras y mejorando la eficiencia del desarrollo.",
      location: "México-Remoto",
    },
  },
  {
    company: "Full Stack Developer Freelancer at SOS Sergio Omar Sánchez",
    designation: "Full Stack Developer",
    dateJoining: "11-2022",
    dateEnd: "04-2023",
    companyLogo: logo,
    work: "- Specializing in designing and implementing complex web applications for my clients. Adept at working independently as a freelancer or as part of a team in a remote environment. Lead full-stack developer with expertise in Next.js, MongoDB, JWT, API, Node.js, and React.js Specializing in designing and implementing complex web applications for my clients Passionate about staying up-to-date with the latest trends and technologies in web development.",
    location: "Córdoba-Argentina",
    es: {
      company: "Desarrollador Full Stack Freelancer en SOS Sergio Omar Sánchez",
      designation: "Desarrollador Full Stack",
      work: "- Especializado en el diseño e implementación de aplicaciones web complejas para mis clientes. Experto en trabajar de forma independiente como freelancer o como parte de un equipo en un entorno remoto. Líder desarrollador full-stack con experiencia en Next.js, MongoDB, JWT, API, Node.js y React.js. Especializado en el diseño e implementación de aplicaciones web complejas para mis clientes. Apasionado por mantenerse al día con las últimas tendencias y tecnologías en desarrollo web.",
      location: "Córdoba-Argentina",
    },
  },
  {
    company: "Sales Executive at Homify",
    designation: "Sales Executive",
    dateJoining: "10.2021",
    dateEnd: "02.2022",
    companyLogo: homifyLogo,
    work: "-Helped our clients to improve their webpage SEO by giving them advice.-Based on the investigation of their webpage and marketing of their company I contacted potential clients to the platform.",
    location: "Berlin-Germany",
    es: {
      company: "Ejecutivo de Ventas en Homify",
      designation: "Ejecutivo de Ventas",
      work: "- Ayudé a nuestros clientes a mejorar el SEO de sus páginas web dando consejos. Basado en la investigación de su página web y el marketing de su empresa, contacté a posibles clientes para la plataforma.",
      location: "Berlín-Alemania",
    },
  },
  {
    company: "Sales/Purchasing agent at Yourwatches.com",
    designation: "Sales/Purchasing",
    dateJoining: "09-2020",
    dateEnd: "06-2021",
    companyLogo: ywLogo,
    work: "Development of new suppliers and merchants, revision of quotation, negotiation with suppliers (Europe, Americas), experience on Chronos 24 platform for Customer Support and Sales. Shipments tracking and follow up and training of new profiles for the Sales and Purchase teams.",
    location: "Copenhagen-Denmark",
    es: {
      company: "Agente de Ventas/Compras en Yourwatches.com",
      designation: "Ventas/Compras",
      work: "Desarrollo de nuevos proveedores y comerciantes, revisión de cotizaciones, negociación con proveedores (Europa, Américas), experiencia en la plataforma Chronos 24 para Soporte al Cliente y Ventas. Seguimiento y seguimiento de envíos y capacitación de nuevos perfiles para los equipos de Ventas y Compras.",
      location: "Copenhague-Dinamarca",
    },
  },
  {
    company: "International Purchasing agent at Systel.SA",
    designation: "Purchasing",
    dateJoining: "07-2017",
    dateEnd: "02-2020",
    companyLogo: systelLogo,
    work: "- Revision of quotation, negotiation with suppliers (United States, Italy, China, Brazil), stock control by MRP (Materials Requirement Planning), shipments tracking and follow up and development of new suppliers",
    location: "Córdoba-Argentina",
    es: {
      company: "Agente de Compras Internacional en Systel.SA",
      designation: "Compras",
      work: "- Revisión de cotizaciones, negociación con proveedores (Estados Unidos, Italia, China, Brasil), control de stock por MRP (Planificación de Requerimientos de Materiales), seguimiento y seguimiento de envíos y desarrollo de nuevos proveedores",
      location: "Córdoba-Argentina",
    },
  },
];
